export function getSelectReviewerColumns(handlers) {
  return getColumns(handlers, selectReviewerColumns);
}

export function getSelectMemberColumns(handlers) {
  return getColumns(handlers, selectMemberColumns);
}

export function getAssignmentColumns(handlers) {
  return getColumns(handlers, assignmentColumns);
}

export function getManagementColumns(handlers) {
  return getColumns(handlers, managementColumns);
}

function getColumns(handlers, columns) {
  return columns.map((column) => {
    if (column.type === "button") {
      column.actions.forEach((action) => {
        action.handler = getHandler(handlers, action);
      });
    }
    return column;
  });
}

function getHandler(handlers, action) {
  return handlers[action.key] || null;
}

const managementColumns = [
  {
    text: "이름",
    value: "name",
    sortBy: "name",
    type: "text",
  },
  {
    text: "이메일",
    value: "email",
    sortBy: "email",
    type: "text",
  },
  // {
  //   text: "소속기관",
  //   value: "department",
  //   type: "text",
  // },
  {
    text: "활동 시작일",
    value: "started_at",
    type: "text",
  },
  {
    text: "활동 종료일",
    value: "ended_at",
    type: "text",
  },
  {
    text: "Actions",
    type: "button",
    actions: [
      {
        icon: "person_off",
        color: "red",
        key: "delete",
        handler: null,
      },
    ],
  },
];

const assignmentColumns = [
  {
    text: "상태",
    value: "status_label",
    type: "text",
    highlighted: true,
  },
  {
    text: "심사위원",
    value: "reviewer_count_label",
    type: "text",
  },
  {
    text: "차수",
    value: "level",
    type: "text",
  },
  {
    text: "제목",
    value: "title",
    type: "text",
  },
  {
    text:"투고자 이름",
    value:"member_name",
    type:"text",
  },
  {
    text: "투고자 소속기관",
    value: "member_organization",
    type: "text",
  },
  {
    text: "Actions",
    type: "button",
    actions: [
      {
        icon: "edit",
        color: "primary",
        key: "assign",
        handler: null,
      },
      /*
      {
        icon: "delete",
        color: "error",
        key: "delete",
        handler: null,
      },
      */
    ],
  },
];

const selectMemberColumns = [
  {
    text: "한글성명",
    value: "name",
    type: "text",
  },
  {
    text: "이메일",
    value: "email",
    sortBy: "email",
    type: "text",
  },
  {
    text: "소속기관",
    value: "organization",
    type: "text",
  },
  {
    text: "부서",
    value: "department",
    type: "text",
  },
  {
    text: "직위",
    value: "position",
    type: "text",
  },
];


const selectReviewerColumns = [
  {
    text: "한글성명",
    value: "name",
    type: "text",
  },
  {
    text: "이메일",
    value: "email",
    type: "text",
  },
  {
    text: "소속기관",
    value: "organization",
    type: "text",
  },
  {
    text: "부서",
    value: "department",
    type: "text",
  },
  {
    text: "직위",
    value: "position",
    type: "text",
  },
  // {
  //   text: "심사중",
  //   value: "review_count",
  //   type: "text",
  // },
  {
    text: "시작일",
    value: "started_at",
    type: "text",
  },
  {
    text: "종료일",
    value: "ended_at",
    type: "text",
  },
];
